import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimRadioGroup } from '../fields';

// Helper to convert boolean to string for RadioGroup, handling null/undefined properly
const boolToRadioValue = (value: boolean | undefined | null): string => {
  if (value === true) return 'true';
  if (value === false) return 'false';
  return '';
};

export const Box27_AcceptAssignment: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">27. ACCEPT ASSIGNMENT?</Typography>
      <Controller
        name="acceptAssignment"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimRadioGroup
            field={field}
            fieldState={fieldState}
            options={[
              { value: true, label: 'YES' },
              { value: false, label: 'NO' },
            ]}
            valueConverter={boolToRadioValue}
            onChangeConverter={(val) => val === 'true' ? true : val === 'false' ? false : undefined}
            row
          />
        )}
      />
    </>
  );
};